var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-error u-bg--red-soft u-color--red"},[_vm._v("\n  Oups... Une erreur est survenue\n")])}
var staticRenderFns = []

export { render, staticRenderFns }